export const ApiEndpoints = {
    auth: {
        login: 'auths/signin',
        forgot: 'auths/forgotPassword',
        otpVerify: 'auths/verify',
        reset: 'auths/resetPassword',
        resendOtp: 'auths/resend',
        updatePassword: 'auths/updatePassword/'
    },

    profile: {
        getProfiles: 'profiles/getProfiles',
        getProfileById: 'profiles/getProfile/',
        createProfile: 'profiles/createProfile',
        updateProfile: 'users/',
    },

    tutorial: {
        getTutorials: 'tutorials/getTutorials',
        createTutorial: 'tutorials/createTutorial',
        updateTutorial: 'tutorials/updateTutorial/',
        getTutorialById: 'tutorials/getTutorial/',
        deleteTutorialById: 'tutorials/deleteTutorials/',
        searchQuery: 'tutorials/getTutorials?search='
    },

    leaderboard: {
        getAllLeaderBoard: 'videoSessions/get/TopVideos',
        getLeadboardRanking: 'videoSessions/get/TopVideos?duration=',
        searchQuery: 'videoSessions/get/TopVideos?search='
    },

    userManagement: {
        getProfiles: 'profiles/getProfiles',
        getListSearchQuery: 'profiles/getProfiles?search=',
        updateProfileStatus: 'profiles/updateProfile/',
        deleteUser: 'users/'
    },

    uploadFile: {
        upload: 'images/upload'
    },

    dashboard: {
        getStats: 'admins/dashboard/stats',
        downloadUserReport: 'admins/dashboard/downloadUserReport',
        videoSessionCounts: 'admins/dashboard/videoSessionCounts'
    }
}